module.exports = __webpack_public_path__ + "img/03-3-4管理功能.6b172efd.svg";